import React from 'react';
import { connect } from 'react-redux';
import { DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationGaitGaitAnalysis extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Gait Analysis' />
                    <label className={styles.label}>Gait Analysis</label>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Arms</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISARMS'
                        className={styles.textfield_long}
                    />
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Trunk</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISTRUNK'
                        className={styles.textfield_long}
                    />
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Pelvis</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISPELVIS'
                        className={styles.textfield_long}
                    />
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Hip</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISHIP'
                        className={styles.textfield_long}
                    />
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Knee</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISKNEE'
                        className={styles.textfield_long}
                    />
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ankle</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISANKLE'
                        className={styles.textfield_long}
                    />
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Toes</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIANALYSISTOES'
                        className={styles.textfield_long}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISARMS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISTRUNK ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISPELVIS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISHIP ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISKNEE ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISANKLE ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIANALYSISTOES
            ? true : false
    };
}


const connectedObservationGaitGaitAnalysis = connect(mapStateToProps)(ObservationGaitGaitAnalysis);
export { connectedObservationGaitGaitAnalysis as ObservationGaitGaitAnalysis };


